<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null"><span class="text">{{ msgAlerta }}</span></div>


    <div class="form-edit-page row-space">
        <div class="row-start">
            <div class="form-item-char40">
                <label class="label-caption">Opções de Relatório</label>
                <select v-model="opcaoSelecionada">
                    <option v-for="opcao in lsOpcoes" :key="opcao.id" :value="opcao.id">{{ opcao.descricao }}</option>
                </select>
            </div>

            <div class="form-item-rangedata"><DateRangeSelect v-model="dateRange" /></div>
            <button type="button" class="buttom-icon--printer" @click="openReport" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
    </div>
</template>


<script setup>
import { ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import DateRangeSelect from '@/components/DateRangeSelect.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const isLoading = ref(false);

const lsOpcoes = ref([
    {id: 'licitacaoSaldos', descricao: 'Licitação - Sintético de Saldos'},
    // {id: 'manut_veiculo_servicos', descricao: 'Serviços por veículo'},
]);
const opcaoSelecionada = ref('licitacaoSaldos');

const closeForm = () => {emit('close');}

const openReport = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        let informacoes = `Período: ${Funcoes.formatDateFromJson(dateRange.value.startDate)} a ${Funcoes.formatDateFromJson(dateRange.value.endDate)}`;
        const dados = {
            nmrelatorio: opcaoSelecionada.value,
            idmunicipio: globalStore.idmunicipio,
            informacoes: informacoes,
            idusuario: globalStore.idusuario,
            idlogin: globalStore.idlogin,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate};
        const response = await Api.genericReport(dados);
        const pdfBlob = new Blob([response], { type: 'application/pdf' });
        const pdfUrl = URL.createObjectURL(pdfBlob);
        window.open(pdfUrl, '_blank');
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}
</script>